import { SimpleGrid, Box } from "@chakra-ui/react";
import { sortBy } from "lodash";

import { HourButton } from "./HourButton";

import { IEReservationIntervalDateGroup } from "modules/appointment/types/IEReservationIntervalDateGroup";
import { IEReservationIntervalElement } from "modules/appointment/types/IEReservationIntervalElement";
import { IntervalElementStatus } from "modules/appointment/types/IntervalElementStatus";

interface IProps {
  selectedDay: IEReservationIntervalDateGroup | undefined;
  setInterval: (interval: IEReservationIntervalElement) => void;
  selectedInterval: IEReservationIntervalElement | null;
}

const AvailableHours = ({
  selectedDay,
  selectedInterval,
  setInterval,
}: IProps) => {
  return (
    <Box maxH="230px" overflowY="auto">
      <SimpleGrid minChildWidth="110px" gap={8} justifyContent="center">
        {sortBy(selectedDay?.intervals, (interval) =>
          interval.startDateTime.toNumber()
        )
          .filter(
            (interval) => interval.status === IntervalElementStatus.Available
          )
          .map((interval) => {
            const isIntervalSelected = interval.id === selectedInterval?.id;
            return (
              <HourButton
                title={interval.startDateTime.getTime()}
                key={interval.id}
                isActive={isIntervalSelected}
                onClick={() => setInterval(interval)}
              />
            );
          })}
      </SimpleGrid>
    </Box>
  );
};

export { AvailableHours };
